import {isArray} from '../main/utils';

export const finishTypes = {
  'Polished Chrome': 'chrome',
  'Brushed Nickel': 'nickel',
  'Polished Brass': 'brass',
  'Brushed Stainless': 'stainless',
  Graphite: 'graphite',
  'Matte Black': 'black',
  'Matte White': 'white'
};

const spoutDesignWeights = {
  '410/415 Low': 1,
  '420/425 Mid': 2,
  'BASYS High': 3,
  'BASYS Mid': 4,
  'BASYS Low': 5,
  'BASYS Integrated Base': 6,
  'BASYS Wall': 7,
  '900 Executive Mid': 8,
  '200/250/275 Mid': 9,
  '100/150 Mid': 10,
  '2400/2450 High': 11,
  '300/350 Mid': 12,
  'EDF-100/150': 13,
  '2100/2150 Mid': 14,
  '800/850 Wall': 15,
  '187/880 Mid': 16,
  '80/85 Mid': 17,
  '2300/2350 Mid': 18,
  '600/650/655 Low': 19,
  '610/615 Low': 20,
  '660/665 Low': 21,
  '700/750 Executive Gooseneck': 22,
  '2200/2250 Gooseneck': 23,
  '700/750/755 Gooseneck': 24,
  '770 Gooseneck': 25,
  '500/550 Wall Gooseneck': 26
};

const facetOrders = {
  product_activation: [
    'Manual',
    'Sensor',
    'Manual Specialty',
    'Sensor Specialty',
    'Solenoid',
    'Solenoid (Less Sensor)'
  ],
  variation_fixture_connection: ['Top Spud', 'Rear Spud', 'Not Included'],
  product_product_line: [
    'CX',
    'TruFlush',
    'G2',
    'ECOS®',
    'SOLIS®',
    'Royal®',
    'UPPERCUT®',
    'Regal®',
    'Sloan®',
    'Crown®',
    'GEM-2®',
    'Naval',
    'Dolphin',
    'No Line'
  ],
  product_fixture_type: ['Water Closet', 'Urinal', 'Service Sink']
};

const excludedFacets = ['Rough Brass'];

export function transformItems(filter, items) {
  const values = items.filter(item => !excludedFacets.includes(item.label));

  switch (filter.id) {
    case 'product_spout_design': {
      return values.sort((a, b) => spoutDesignSort(a, b));
    }
    case 'variation_finish': {
      return sortFinishes(values);
    }
    case 'variation_flow_rate': {
      return sortFlowRates(values);
    }
    default: {
      if (filter.type === 'number') return values.sort((a, b) => a.value - b.value);

      return sortFacet(filter.id, values);
    }
  }
}

function sortFinishes(values) {
  const names = Object.keys(finishTypes);
  return values
    .map((item, i) => {
      const order = names.indexOf(item.label);
      item._order = order !== -1 ? order : i * 10;
      return item;
    })
    .sort((a, b) => (a._order < b._order ? -1 : 1));
}

export function scrollToTopAfterFilterChange() {
  window.scrollTo({top: 0, left: 0, behavior: 'instant'});
}

function sortFlowRates(values) {
  return values.sort((a, b) => (a.value < b.value ? -1 : 1));
}

function spoutDesignSort(a, b) {
  const aWeight = spoutDesignWeights[a.label] ? spoutDesignWeights[a.label] : 100;
  const bWeight = spoutDesignWeights[b.label] ? spoutDesignWeights[b.label] : 100;
  return aWeight - bWeight;
}

function sortFacet(key, values) {
  let facetOrder = facetOrders[key];
  if (!isArray(facetOrder)) return values;

  facetOrder = facetOrder.map(name => name.toLowerCase());

  return values
    .map((item, i) => {
      const order = facetOrder.indexOf(item.label.toLowerCase());
      item._order = order !== -1 ? order : i * 100;
      return item;
    })
    .sort((a, b) => (a._order < b._order ? -1 : 1));
}

export function isVolume(filterId) {
  return [
    'variation_flow_rate',
    'product_flush_volume',
    'variation_flush_volume',
    'flushometer_variation_flush_volume'
  ].includes(filterId);
}

export function isFlowRate(filterId) {
  return ['variation_flow_rate'].includes(filterId);
}

export function isWaterfree(value) {
  return ['Waterfree', 'sin agua', '直冲式'].includes(value);
}

export const hasVariations = index =>
  ['accessory', 'bottle_filler', 'faucet', 'flushometer', 'hand_dryer', 'mirror', 'showerhead', 'sink', 'soap_dispenser']
    .includes(index);

export const hasToggle = index => {
  const filters = config[index];
  if (!filters) return false;

  return filters.some(filter => filter.type === 'toggle');
};

const config = {
  accessory: [
    {
      id: 'product_product_type',
      label: 'Product Type',
      type: 'checkbox',
      visible: true
    },
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'checkbox',
      visible: true
    },
    {
      id: 'product_accessory_sub_type',
      label: 'Accessory Type',
      type: 'checkbox',
      visible: true
    }
  ],
  bottle_filler: [
    {
      id: 'product_configuration',
      label: 'Configuration',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: true
    },
    {
      id: 'variation_filter_option',
      label: 'Filter Option',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_refrigeration_option',
      label: 'Refrigeration Option',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  urinal: [
    {
      id: 'product_flush_method',
      label: 'Flush Method',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_urinal_type',
      label: 'Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_flush_volume',
      label: 'Flush Volume',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_fixture_connection',
      label: 'Fixture Connection',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_sloantec_glaze',
      label: 'SloanTec® Hydrophobic Glaze',
      type: 'toggle',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  water_closet: [
    {
      id: 'product_mounting',
      label: 'Fixture Mount',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_floor_mount_type',
      label: 'Floor Mount Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_fixture_connection',
      label: 'Fixture Connection',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_flush_volume',
      label: 'Flush Volume',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_rough_in_dimensions',
      label: 'Rough-in Dimensions',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_sloantec_glaze',
      label: 'SloanTec® Hydrophobic Glaze',
      type: 'toggle',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  closet_combo: [
    {
      id: 'flushometer_product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: true
    },
    {
      id: 'water_closet_product_mounting',
      label: 'Fixture Mount',
      type: 'generic',
      visible: true
    },

    {
      id: 'flushometer_variation_flush_volume',
      label: 'Flush Volume',
      type: 'generic',
      visible: true
    }
  ],
  urinal_combo: [
    {
      id: 'flushometer_product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: true
    },
    {
      id: 'urinal_product_urinal_type',
      label: 'Urinal Type',
      type: 'generic',
      visible: true
    },

    {
      id: 'flushometer_variation_flush_volume',
      label: 'Flush Volume',
      type: 'generic',
      visible: true
    },
    {
      id: 'urinal_product_retrofit',
      label: 'Retrofit',
      type: 'toggle',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  sink: [
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_material',
      label: 'Material',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_stations',
      label: 'Stations',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_variable_width',
      label: 'Variable Size',
      type: 'toggle',
      visible: false
    },
    {
      id: 'variation_sink_mounting_type',
      label: 'Mounting Type',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_verticals',
      label: 'Verticals',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_building_types',
      label: 'Building Types',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    },
    {
      id: 'product_mounting',
      label: 'Mounting',
      type: 'generic',
      visible: false
    }
  ],
  faucet_soap_dispenser_combo: [
    {
      id: 'faucet_variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: true
    },
    {
      id: 'faucet_variation_flow_rate',
      label: 'Flow Rate',
      type: 'generic',
      visible: true
    },
    {
      id: 'soap_dispenser_product_soap_type',
      label: 'Soap Type',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  product: [
    {
      id: 'variation_type',
      label: 'Product Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: true
    }
  ],
  lavatory: [
    {
      id: 'product_lavatory_type',
      label: 'Lavatory Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_centerset',
      label: 'Centerset',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  mirror: [
    {
      id: 'variation_mirror_type',
      label: 'Mirror Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_finish',
      label: 'Frame Finish',
      type: 'finish',
      visible: true
    },
    {
      id: 'variation_mirror_size',
      label: 'Mirror Size',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_frame_type',
      label: 'Frame Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_frame_width',
      label: 'Frame Width',
      type: 'generic',
      visible: true
    }
  ],
  showerhead: [
    {
      id: 'variation_flow_rate',
      label: 'Flow Rate',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_showerhead_type',
      label: 'Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_pwt',
      label: 'PWT',
      type: 'toggle',
      visible: false
    }
  ],
  soap_dispenser: [
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: true
    },
    {
      id: 'product_soap_type',
      label: 'Soap Type',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_soap_fill',
      label: 'Soap Fill',
      type: 'generic',
      visible: true
    },
    {
      id: 'product_power_type',
      label: 'Power Type',
      type: 'icon',
      visible: true
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: true
    }
  ],
  hand_dryer: [
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: true
    },
    {
      id: 'product_high_efficiency',
      label: 'High Efficiency',
      type: 'toggle',
      visible: false
    },
    {
      id: 'product_activation',
      label: 'Activation',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_mounting',
      label: 'Mounting',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  faucet: [
    {
      id: 'product_spout_design',
      label: 'Spout Design',
      type: 'icon',
      visible: true
    },
    {
      id: 'variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: false
    },
    {
      id: 'product_power_type',
      label: 'Power Type',
      type: 'icon',
      visible: false
    },
    {
      id: 'variation_flow_rate',
      label: 'Flow Rate',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_spray_type',
      label: 'Spray Type',
      type: 'icon',
      visible: false
    },
    {
      id: 'variation_mixer',
      label: 'Mixer',
      type: 'icon',
      visible: false
    },
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_trim_plate',
      label: 'Trim Plate (in)',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_mounting',
      label: 'Mounting Type',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_smart_faucet',
      label: 'Smart Faucet',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_guided_handwashing_display',
      label: 'Guided Handwashing Display',
      type: 'toggle',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  flushometer: [
    {
      id: 'product_fixture_type',
      label: 'Fixture Type',
      type: 'icon',
      visible: true
    },
    {
      id: 'product_activation',
      label: 'Activation',
      type: 'generic',
      visible: true
    },
    {
      id: 'variation_power_type',
      label: 'Power',
      type: 'icon',
      visible: true
    },
    {
      id: 'variation_flush_volume',
      label: 'Flush Volume',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_installation',
      label: 'Installation',
      type: 'icon',
      visible: false
    },
    {
      id: 'variation_fixture_connection',
      label: 'Fixture Connection',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_valve',
      label: 'Valve',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_finish',
      label: 'Finish',
      type: 'finish',
      visible: false
    },
    {
      id: 'product_specialty',
      label: 'Specialty',
      type: 'generic',
      visible: false
    },
    {
      id: 'product_product_line',
      label: 'Product Line',
      type: 'icon',
      visible: false
    },
    {
      id: 'product_smart_flushometer',
      label: 'Smart Flushometer',
      type: 'generic',
      visible: false
    },
    {
      id: 'variation_compliances_certifications',
      label: 'Compliances',
      type: 'checkbox',
      visible: false
    }
  ],
  part: [
    {
      id: 'variation_product_type',
      label: 'Product Type',
      type: 'checkbox',
      visible: true
    },
    {
      id: 'variation_product_lines',
      label: 'Product Line',
      type: 'checkbox',
      visible: true
    },
    {
      id: 'variation_part_type',
      label: 'Part Type',
      type: 'checkbox',
      visible: true
    }
  ]
};

export default config;
